<template>
  <div class="checkStats_container">
    <Header :title="title" :showBack="true"></Header>
    <!-- 日期 -->
    <form>
      <div class="date_content">
        <span>日期：</span>
        <div class="date_input" @click.stop="$refs.calendar.show = true">
          {{ beginDate }} ~ {{ endDate }}
        </div>
        <button class="flex-1 search_btn" type="button" @click="doQuery">
          查询
        </button>
      </div>
    </form>
    <van-list
      class="m-1"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
      ref="list"
    >
      <div class="stats_panel">
        <ul class="flex text-center w-full">
          <li class="flex-1">
            <p class="stats_item_title">班次数</p>
            <p class="stats_item_value">{{ totalData.TotalClassCount }}班</p>
          </li>
          <li class="flex-1">
            <p class="stats_item_title">总检票数</p>
            <p class="stats_item_value">{{ totalData.TotalCheckCount }}张</p>
          </li>
        </ul>
      </div>
      <div class="stats_panel mt-1" v-for="(item, index) in list" :key="index">
        <ul class="class_info">
          <li>
            <span class="info_name">班次日期：</span>
            <span class="info_value"
              >{{ item.ClassDate }} {{ item.ClassTime }}</span
            >
          </li>
          <li>
            <span class="info_name">车牌：</span>
            <span class="info_value">{{ item.VehicleNo }}</span>
          </li>
          <li>
            <span class="info_name">线路名称：</span>
            <span class="info_value">{{ item.LineName }}</span>
          </li>
        </ul>
        <ul class="node_info">
          <li v-for="(nItem, nIndex) in item.CheckNodeList" :key="nIndex">
            <span class="info_name">{{ nItem.NodeName }}</span>
            <p class="info_value">{{ nItem.CheckCount }}人</p>
          </li>
        </ul>
        <div class="detail_btn">
          <b>班次检票合计：{{ item.totalCheckCount }}人</b>
        </div>
      </div>
    </van-list>
    <Calendar
      ref="calendar"
      type="range"
      :allow-same-day="true"
      @confirm="onConfirm"
    ></Calendar>
  </div>
</template>

<script>
import "@/views/AnalysisStats/style.less";
import Header from "@/components/Header/Header.vue";
import Calendar from "../../components/calendar.vue";
export default {
  components: {
    Header,
    Calendar,
  },
  data() {
    let now = new Date();
    return {
      title: "检票统计",
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")),
      loading: false,
      finished: false,
      beginDate: this.$moment(now).format("YYYY-MM-DD"),
      // beginDate: this.$moment(now).subtract(1, 'year').format('YYYY-MM-DD'),
      endDate: this.$moment(now).format("YYYY-MM-DD"),
      start: 0,
      limit: 5,
      list: [],
      totalData: {
        TotalCheckCount: 0,
        TotalClassCount: 0,
      },
      beginDateShow: false,
      endDateShow: false,
    };
  },
  methods: {
    onConfirm(date) {
      this.beginDate = this.$moment(date[0]).format("YYYY-MM-DD");
      this.endDate = this.$moment(date[1]).format("YYYY-MM-DD");
    },
    doQuery() {
      this.list = [];
      this.start = 0;
      this.finished = false;
      this.loading = false;
      this.$nextTick(() => this.$refs.list.check());
    },
    onLoad() {
      this.$http
        .post(this.$api.DriverTicketCheckDataQuery, {
          DriverGID: this.operObj.GID,
          BeginDate: this.$moment(this.beginDate).format("YYYY-MM-DD 00:00:00"),
          EndDate: this.$moment(this.endDate).format("YYYY-MM-DD 23:59:59"),
          start: this.start,
          limit: this.limit,
        })
        .then((res) => {
          let list = res.data;
          list.forEach((i) => {
            i.CheckNodeList = JSON.parse(i.CheckNodeList);
            i.totalCheckCount = 0;
            i.CheckNodeList.forEach((j) => (i.totalCheckCount += j.CheckCount));
            this.list.push(i);
          });
          this.totalData = res.totalData[0];

          this.start += this.limit;
          this.loading = false;

          if (this.list.length >= this.totalData.TotalClassCount) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
          this.loading = false;
        });
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs.list.check());
  },
};
</script>

<style lang="less" scoped>
.checkStats_container {
  display: flex;
  flex-direction: column;
  font-size: 0.385rem;

  // 日期
  .date_content {
    display: flex;
    background: #fff;
    padding: 0.256rem;
    line-height: 0.75rem;

    .date_split {
      margin: 0 0.256rem;
    }

    .date_input {
      border-bottom: 1px solid #000;
      width: 5.692rem;
      font-size: 0.359rem;
    }

    .van-button {
      flex: 1;
      margin-left: 0.128rem;
      line-height: 1;
    }
  }

  //
  .stats_container {
    .stats_panel {
      margin-bottom: 0.256rem;
    }

    .stats_item_list {
      margin-top: 0;
    }
  }

  .class_info {
    font-size: 0.333rem;
    display: flex;
    flex-wrap: wrap;

    li {
      margin-top: 0.128rem;

      &:nth-child(1) {
        width: 60%;
      }

      &:nth-child(2) {
        flex: 1;
      }

      &:nth-child(3) {
        margin-top: 0.256rem;
        width: 100%;
      }
    }
  }

  .info_name {
    color: #aaa;
  }

  .node_info {
    margin-top: 0.256rem;
    display: flex;

    li {
      width: 33.3%;
      padding: 0.128rem;
      text-align: center;
      position: relative;

      .info_value {
        font-size: 0.462rem;
        font-weight: bolder;
        color: #ff9900;
      }

      &::after {
        content: "";
        position: absolute;
        top: 0.064rem;
        left: 0.064rem;
        width: calc(100% - 0.192rem);
        height: calc(100% - 0.128rem);
        border: 1px solid #aaa;
        border-radius: 10px;
      }
    }
  }
}
</style>